/* GRADAZONE — carrusel de bucle infinito, reutilizable.
 *
 * Sale del carrusel de recomendados del carrito, que era el unico sitio que lo tenia. Se
 * extrajo tal cual al necesitar el mismo comportamiento en el selector de colores del hero:
 * duplicar la logica habria significado dos bucles que se desincronizan y dos sitios donde
 * arreglar el mismo fallo.
 *
 * Como funciona y por que asi:
 * · El desplazamiento NO es scroll nativo sino un `translateX` sobre un `offset` que mueve un
 *   bucle de requestAnimationFrame. Con scroll nativo no hay forma de encadenar el salto del
 *   final al principio sin que se note el tiron.
 * · El bucle es infinito porque el track lleva el contenido DUPLICADO: cuando el offset pasa
 *   de la mitad del ancho se le resta esa mitad, y como la segunda mitad es identica a la
 *   primera el salto es invisible. Quien llama es responsable de duplicar los elementos.
 * · Todo (auto-avance, arrastre y saltos con flecha) escribe sobre el MISMO `offset`. Es la
 *   leccion del bug anterior: las flechas escribian `transform` por su cuenta y el bucle se
 *   lo machacaba en el siguiente frame.
 * · Al tocar se pausa y se reanuda 2 s despues de soltar, para que los toques acierten.
 *
 * Uso:
 *   window.GZ_carrusel(track, {
 *     itemSel:  '.mi-item',        // para medir el salto de las flechas
 *     hueco:    10,                // gap en px entre items
 *     velocidad: 0.3,              // px por frame
 *     onTap:    function (el) {}   // que hacer con un toque limpio (sin arrastre)
 *   });
 * Devuelve el track, que expone `_empujar(±1)` para las flechas.
 */
(function () {
  window.GZ_carrusel = function (track, opciones) {
    var o = opciones || {};
    var wrap = track.parentElement;
    if (!track || !wrap) return null;

    var itemSel = o.itemSel || null;
    var hueco = typeof o.hueco === 'number' ? o.hueco : 10;
    var velocidad = typeof o.velocidad === 'number' ? o.velocidad : 0.3;
    var onTap = typeof o.onTap === 'function' ? o.onTap : null;

    wrap.style.overflow = 'hidden';
    track.style.willChange = 'transform';
    track.style.animation = 'none';

    var offset = 0, mitad = 0, arrastrando = false;
    var inicioX = 0, inicioOffset = 0, movido = false, pulsadoEn = 0;
    var pausado = false, reanudarTO = null;

    var aplica = function () { track.style.transform = 'translateX(' + (-offset) + 'px)'; };
    var normaliza = function () {
      if (mitad > 0) { while (offset >= mitad) offset -= mitad; while (offset < 0) offset += mitad; }
    };

    function tick() {
      if (!mitad) mitad = track.scrollWidth / 2;
      if (!pausado && !arrastrando && mitad && !document.hidden) { offset += velocidad; normaliza(); aplica(); }
      track._raf = requestAnimationFrame(tick);
    }
    if (track._raf) cancelAnimationFrame(track._raf);
    track._raf = requestAnimationFrame(tick);

    function reanudarPronto() {
      clearTimeout(reanudarTO);
      reanudarTO = setTimeout(function () { pausado = false; }, 2000);
    }

    // Salto de un item, animado a mano sobre el MISMO offset que usa el bucle.
    track._empujar = function (dir) {
      var item = itemSel ? track.querySelector(itemSel) : track.firstElementChild;
      var salto = item ? (item.getBoundingClientRect().width + hueco) : 132;
      if (!mitad) mitad = track.scrollWidth / 2;
      pausado = true; clearTimeout(reanudarTO);
      var desde = offset, hasta = offset + dir * salto, t0 = null;
      function anima(ts) {
        if (t0 === null) t0 = ts;
        var k = Math.min(1, (ts - t0) / 320);
        k = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;   // easeInOutQuad
        offset = desde + (hasta - desde) * k;
        normaliza(); aplica();
        if (k < 1) requestAnimationFrame(anima);
        else reanudarPronto();
      }
      requestAnimationFrame(anima);
    };

    // ---- dedo ----
    wrap.addEventListener('touchstart', function (e) {
      var p = e.touches[0];
      arrastrando = true; pausado = true; clearTimeout(reanudarTO);
      inicioX = p.clientX; inicioOffset = offset; movido = false; pulsadoEn = Date.now();
      if (!mitad) mitad = track.scrollWidth / 2;
    }, { passive: true });

    wrap.addEventListener('touchmove', function (e) {
      if (!arrastrando) return;
      var dx = e.touches[0].clientX - inicioX;
      if (Math.abs(dx) > 6) movido = true;
      offset = inicioOffset - dx; normaliza(); aplica();
    }, { passive: true });

    wrap.addEventListener('touchend', function (e) {
      arrastrando = false;
      // toque limpio (ni arrastre ni pulsacion larga) -> se trata como clic
      if (!movido && Date.now() - pulsadoEn < 700 && onTap) {
        var p = e.changedTouches[0];
        var el = document.elementFromPoint(p.clientX, p.clientY);
        if (el && onTap(el, e) === true) e.preventDefault();
      }
      reanudarPronto();
    }, { passive: false });

    // ---- raton ----
    var rDown = false, rX = 0, rOff = 0, rMovido = false;
    wrap.addEventListener('mousedown', function (e) {
      rDown = true; pausado = true; clearTimeout(reanudarTO);
      rX = e.clientX; rOff = offset; rMovido = false;
      if (!mitad) mitad = track.scrollWidth / 2;
    });
    window.addEventListener('mousemove', function (e) {
      if (!rDown) return;
      var dx = e.clientX - rX;
      if (Math.abs(dx) > 4) rMovido = true;
      offset = rOff - dx; normaliza(); aplica();
    });
    window.addEventListener('mouseup', function () {
      if (!rDown) return;
      rDown = false; reanudarPronto();
    });
    wrap.addEventListener('click', function (e) {
      // si venia de arrastrar, el clic no cuenta: si no, arrastrar abriria un producto
      if (rMovido) { e.preventDefault(); e.stopPropagation(); return; }
      if (onTap && onTap(e.target, e) === true) e.preventDefault();
    });

    // se para al pasar el raton por encima, para poder mirar sin perseguir
    wrap.addEventListener('mouseenter', function () { pausado = true; clearTimeout(reanudarTO); });
    wrap.addEventListener('mouseleave', function () { if (!rDown) reanudarPronto(); });

    return track;
  };
})();
